<template>

    <b-row>

        <b-col>

            <b-card
                header="Send Mass Message"
                header-text-variant="white"
                header-bg-variant="info">

                <b-row class="mb-2">

                    <b-col sm="6" md="6" class="my-1">

                        <b-form-group label="Carrier Block" label-for="ltc_carrier_id">

                            <carrier-dropdown v-model=" blast.ltc_carrier_id " id="ltc_carrier_id" name="ltc_carrier_id"></carrier-dropdown>
                            <input-help :form=" blast " field="ltc_carrier_id" text="Changing this will clear the template and recipients"></input-help>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" class="my-1">

                        <b-form-group label="Template" label-for="template_id">

                            <b-form-select v-model=" blast.template_id " id="template_id" name="template_id">

                                <option value="">-- Choose A Template --</option>
                                <option v-for=" template in scopedTemplates " :key=" `template${template.id}` " :value=" template.id ">{{ template.title }}</option>
                            </b-form-select>
                            <input-help :form=" blast " field="template_id" text=""></input-help>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12">

                        <b-form-group label="Template Body" label-for="body">

                            <b-form-textarea
                                id="body"
                                name="body"
                                :rows=" 5 "
                                :value=" selectedTemplateBody "
                                disabled
                            >
                            </b-form-textarea>
                            <input-help :form=" blast " field="body" text="View the message body before sending"></input-help>
                        </b-form-group>
                    </b-col>
                    <b-col>

                        <b-row>

                            <b-col>

                                <b-form-group label="Recipients" label-for="recipient_type">

                                    <b-form-select v-model=" blast.recipient_type " id="recipient_type" name="recipient_type">

                                        <option value="manual">-- Manually Select Recipients --</option>
                                        <option value="unenrolled_claimants">All Unenrolled Claimants</option>
                                        <option value="unenrolled_providers">All Unenrolled Providers</option>
                                    </b-form-select>
                                    <input-help :form=" blast " field="recipient_type" text="Changing this will clear recipients"></input-help>
                                </b-form-group>
                            </b-col>
                            <b-col>

                                <label class="d-block">Manual Add</label>

                                <user-search-dropdown
                                    placeholder="Add Single Recipient"
                                    icon="fa-plus"
                                    :carrier-based=" true "
                                    :passes-carrier=" true "
                                    @selectUser=" addRecipient "
                                    type="phone"
                                    :passed-carrier=" blast.ltc_carrier_id || 0 "
                                    :disabled=" blast.recipient_type != 'manual' "
                                    class="mb-2"
                                />
                            </b-col>
                            <b-col sm="12">

                                <b-badge pill
                                    :href=" `/business/${recipient.role_type}s/${recipient.id}` "
                                    target="_blank"
                                    v-for=" recipient in blast.recipients "
                                    :key=" recipient.id"
                                    variant="light">

                                    {{ `${recipient.name} ${recipient.phone || '-- no phone on record --'}` }}

                                    <a href="#" class="delete-btn" @click.stop="removeRecipient( recipient.id )"><i class="fa fa-times"></i></a>
                                </b-badge>
                            </b-col>
                            <b-col sm="12" class="d-flex align-items-center justify-content-end">

                                <b-button variant="info" @click=" fullSend() ">Send Message</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

            </b-card>
        </b-col>
    </b-row>
</template>

<script>

    export default {

        props : {

            templates : Array
        },
        data(){

            return {

                blast   : new Form({}),
                loading : false
            }
        },
        computed: {

            scopedTemplates(){

                if( !this.blast.ltc_carrier_id ) return [];

                return this.templates.filter( template => template.ltc_carrier_id == this.blast.ltc_carrier_id );
            },
            selectedTemplateBody(){

                if( !this.blast.template_id ) return '-- None Selected --';

                return this.templates.find( template => template.id == this.blast.template_id ).body;
            }
        },
        methods: {

            setForm(){

                this.blast = new Form({

                    ltc_carrier_id : '',
                    template_id    : '',
                    recipient_type : 'manual',
                    recipients     : []
                })
            },
            addRecipient( recipient ){

                this.removeRecipient( recipient.id ); // prevent duplicates
                this.blast.recipients.push( recipient );
            },
            removeRecipient( id ){

                let index = this.blast.recipients.findIndex( item => item.id === id );
                if( index !== -1 ) this.blast.recipients.splice( index, 1 );
            },
            fullSend(){

                if( this.blast.recipient_type == 'manual' && this.blast.recipients.length == 0 ) alerts.addMessage( 'warning', 'Must select recipients first!' );
                else {

                    this.blast.post( '/business/text_blast' )
                        .then( res => console.log( res.data ) )
                        .finally( () => this.loading = false );
                }
            }
        },
        created(){

            this.setForm();
        },
        watch: {

            'blast.ltc_carrier_id'(){

                this.blast.template_id = '';
                this.blast.recipients  = [];
            },
            'blast.recipient_type'(){

                this.blast.recipients = [];
            }
        }
    }
</script>

<style>

</style>